module.exports = __webpack_public_path__ + "img/back-img1.png";